export default __webpack_public_path__ + "static/home_bodegon_ecuador-f88c5254427ea3bd7c1cc8cb24144512.png";